import { assetURL } from '../api/utils';

/** Recives a url or file key if development */
export const getAssetUrl = url => {
  if (url.startsWith('http') || url.startsWith('https')) return url;

  return `http://localhost:5000${assetURL}${url}`;
};
